// Whether a PAC (pre-anaesthesia check) outcome may be recorded on a case,
// given its current lifecycle status.
//
// Mirrors the server-side gate exactly, so the UI never offers "Record
// outcome" on a case the endpoint will refuse:
//   - manage_preop.CasePacView.post
//   - ot_common.PAC_CLOSED_STATUSES
//
// A case in one of these statuses is finished, abandoned, or already past the
// point where an anaesthetic clearance means anything -- POSTPONED still
// allows it (a FIT outcome there returns the case to SCHEDULED), and every
// other status not listed here allows it too.
const PAC_CLOSED_STATUSES = ["CANCELLED", "CLOSED", "IN_OR", "IN_RECOVERY", "DRAFT"];

export function canRecordPacOutcome(lifecycleStatus) {
  return !PAC_CLOSED_STATUSES.includes(lifecycleStatus);
}
